import { isPageVisible } from '@helpers/engine/page-visibility';
import type { NotificationCategory } from '@interfaces';
import { Subject } from 'rxjs';

const notification = new Subject<{
  message: string;
  type: 'info' | 'error' | 'success' | 'warning';
  category: NotificationCategory;
  onClick?: () => void;
}>();
export const notification$ = notification.asObservable();

export function notify(category: NotificationCategory, message: string): void {
  if (!isPageVisible()) return;

  notification.next({ message, type: 'info', category });
}

export function notifyError(message: string): void {
  if (!isPageVisible()) return;
  notification.next({ message, type: 'error', category: 'Error' });
}

export function notifyWarning(message: string): void {
  if (!isPageVisible()) return;
  notification.next({ message, type: 'warning', category: 'Warning' });
}

export function notifySuccess(message: string, onClick?: () => void): void {
  if (!isPageVisible()) return;
  notification.next({ message, type: 'success', category: 'Success', onClick });
}
